module.exports = __webpack_public_path__ + "static/media/elegirSucursal_map.df2bbd38.svg";